import React, {Suspense, useState} from 'react';
import {gcp} from '@config/api';

/**
 * composant qui retourne un emoji lorsqu'on lui passe le nom de l'emoji
 *
 * il dispose d'un ErrorBoundary pour catch n'importe quelle erreur
 *
 * @param {string} name nom de l'emoji
 * @returns
 */
const EmojiIcon = ({name}) => {
    const [imageError, setImageError] = useState(false);
    const {cloudStorageUrl} = gcp;
    const extension = name === 'ellipsis' ? 'svg' : 'png';
    const emojiUrl = `${cloudStorageUrl}${name}.${extension}`;

    const defaultImageUrl = `${cloudStorageUrl}rocket.png`;
    const handleImageError = () => {
        setImageError(true);
    };

    return (
        <Suspense fallback={<div></div>}>
            <img width={32} height={32} src={imageError ? defaultImageUrl : emojiUrl} alt={name}
                 onError={handleImageError}
            />
        </Suspense>
    );
};

export default EmojiIcon;
